import React, {Component} from 'react';

// Components
import '../../styles/elements/portfolioInfo.css';


class PortfolioInfo extends Component {

  project;

  render() {
    this.project = this.props.project;

    return (
      <div className="portfolio-info">
        <img src={this.project.logo} className="portfolio-info__logo" alt="background"/>
        <h2 className="portfolio-info__title">
          {this.project.name}
        </h2>
        <ul className="portfolio-info__info">
          <li className="portfolio-info__info-element">
            <div className="portfolio-info__info-title">Role:</div>
            <div className="portfolio-info__info-value">{this.project.role}</div>
          </li>
          <li className="portfolio-info__info-element">
            <div className="portfolio-info__info-title">Relation:</div>
            <div className="portfolio-info__info-value">{this.project.relation}</div>
          </li>
        </ul>
        <div className="portfolio-info__description">
          {this.project.description}
        </div>
        <div className="portfolio-info__tags">
          {this.project.tags.map((tag, i) => {
            return (<span key={"pi" + i} className="portfolio-info__tag">{tag}</span>)
          })
          }
        </div>
        {this.project.url ? (
          <a href={this.project.url} className={"portfolio-info__link " + (!this.project.url ? 'portfolio-info__link--disabled' : '')} target="_blank" rel="noopener noreferrer">
          See the result
          </a>):''
        }
      </div>
    );
  }
}

export default PortfolioInfo;


// WEBPACK FOOTER //
// ./src/js/elements/PortfolioInfo.js